import bckImg from '../../assets/images/landing_bg.jpg'
const styles = theme => ({
  safeLogo: {
    width: '400px',
    paddingTop: '10px'
  },
  pinLeftLogo: {
    width: '156.8px',
    marginBottom: 20,
    marginRight: 9,
    marginTop: 10
  },
  loginWrapper: {
    padding: '20px'
  },
  app: {
    height: '100vh',
    textAlign: 'center',
    // overflow: 'hidden',
    // position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'space-around',
    backgroundColor: '#000000',
    backgroundImage: `url(${bckImg})`
  },
  cardWrapper: {
    paddingTop: '50px',
    minHeight: 'calc(100% - 276px)',
    borderRadius: '0',
    overflow: 'auto'
  },
  formGroup: {
    flexGrow: 1,
    position: 'relative'
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '75%',
    margin: theme.spacing.unit
  },
  largeButton: {
    margin: 'auto',
    width: '84%',
    paddingTop: '10px',
    color: '#fff'
    // backgroundColor: '#000000'
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    alignContent: 'space-between',
    justifyContent: 'space-evenly',
    margin: 'auto',
    width: `${75}%`,
    padding: '15px 0px'
  },
  buttonReg: {
    padding: '8px 24px'
  },
  copyRight: {
    margin: 'auto',
    position: 'absolute',
    right: '0',
    bottom: 0,
    left: '0',
    marginBottom: theme.spacing.unit * 1
  },
  copyRightText: {
    color: theme.palette.primary.dark,
    width: '100%',

    fontSize: 11
  },
  forgotLoginButtonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  wrapper: {
    flexFlow: 'row wrap'
  },
  actionsRoot: {
    justifyContent: 'center'
  },
  loginForm: {
    height: 248,
    // maxWidth: '800px',
    textAlign: 'center'
  },
  registerForm: {
    // height: 244,
    '@media (max-width: 599px)': {
      height: 416
    }
  },
  header: {
    margin: '75px 0px',
    textAlign: 'center'
    // backgroundImage: `url(${bckImg})`
  },
  form: {
    // paddingBottom: `${theme.spacing.unit * 2}`,
    // top: '50%',
    // width: '100%',
    '@media (max-width: 599px)': {
      transform: ['translate(0,0)', '!important'],
      top: 0
    }
  },
  pinInputWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: `0 ${theme.spacing.unit * 2}px`
  },
  pinInput: {
    margin: `0 ${theme.spacing.unit * 2}px`
  },
  pinInputInput: {
    textAlign: 'center'
  },
  cardContentRoot: {
    padding: '0px 20px 40px 20px'
  },
  cardContentRootRegister: {
    padding: '0px 20px 40px 20px',
    margin: '0px 45px'
  },
  registerButtonsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  registerHeading: {
    fontSize: '21px',
    fontWeight: '600',
    color: '#323233',
    marginBottom: '12px',
    marginTop: '20px'
  },
  radioGroup: {
    flexDirection: 'row'
  },
  loginheading:{
    fontSize:'16px',
    fontWeight:'600',
    color:'#323233',
    textAlign:'left',
    marginBottom:'33px',
    textTransform:'uppercase',
    fontFamily: 'Titillium-SemiBold, Helvetica Neue, sans-serif',
  },

  loginform:{
    width:'100%',
  }
})

export default styles
